module.exports = __webpack_public_path__ + "static/media/google-play-qrcode.2e798318.png";